import React from 'react'
import { hasCoachAdditionalInfo } from '../../../utils/hasCoachAdditionalInfo'
import { getCoachAvatarUrl } from '../getCoachAvatarUrl'
import CoachActionButtons from './CoachActionButtons'
import CoachExpandedInfo from './CoachExpandedInfo'

/**
 * Available coach card — shared by modal list and video-frame picker.
 */
function AvailableCoachCard({
  coach,
  jobTitle,
  isExpanded,
  onToggleExpanded,
  onSelect,
  userCareerDevelopment = false,
  mediaAvailable = true,
  actionLabels,
  moreInfoLabel,
  showLessLabel,
  expandedLabels,
  translateSkill,
}) {
  const showMoreInfo = hasCoachAdditionalInfo(coach)

  return (
    <div className="coach-row-content card relative block rounded-2.5xl border border-intoo-green-medium-100 bg-intoo-green-medium-50 shadow-md @container">
      <div className="grid grid-cols-1 items-center gap-4 p-4 @md:grid-cols-[auto_1fr_auto]">
        <div className="flex w-full flex-col items-center self-end @md:-mb-4 @md:mt-[-40px] @md:w-auto">
          <img
            src={getCoachAvatarUrl(coach)}
            alt={coach.displayName}
            className="h-30 w-28 object-contain"
          />
        </div>
        <div className="flex flex-col items-center leading-5 text-cod-gray-700 @md:items-start">
          <strong className="text-cod-gray-900">{coach.displayName}</strong>
          <span className="text-sm">{jobTitle}</span>
          {showMoreInfo && (
            <button
              type="button"
              className="mt-1 cursor-pointer text-sm text-intoo-green-medium-800 hover:text-intoo-green-medium-900 active:text-intoo-green-medium-900"
              onClick={(e) => {
                e.preventDefault()
                onToggleExpanded(coach.easyrtcid)
              }}
            >
              {isExpanded ? showLessLabel : moreInfoLabel}
            </button>
          )}
        </div>
        <CoachActionButtons
          coach={coach}
          userCareerDevelopment={userCareerDevelopment}
          mediaAvailable={mediaAvailable}
          onSelect={onSelect}
          labels={actionLabels}
        />
      </div>
      {showMoreInfo && isExpanded && (
        <CoachExpandedInfo
          coach={coach}
          translateSkill={translateSkill}
          labels={expandedLabels}
        />
      )}
    </div>
  )
}

export default AvailableCoachCard
